import React, { useEffect, useContext, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';

import { getFunds } from '../../../services/fundsService';

import { filterBy } from '@progress/kendo-data-query';

import FilterCtx from '../../../../context/filterContext/filterCtx';
import { RootState } from '../../../../redux/store';
import { POPUP } from '../../../../redux/types';

import { IFund } from '../../../services/types/IFund';
import { IFundsFilter } from '../../types/IFundsFilter';

import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Switch } from '@progress/kendo-react-inputs';

import '../../multiselect/multiselect.scss';
import '../filters.scss';

const FundsFilter: React.FC<IFundsFilter> = ({ table, toggleOn }) => {
  const [value, setValue] = useState<IFund[]>([]);
  const [filterChoice, setFilterChoice] = useState<IFund[]>([]);
  const [cashChoice, setCashChoice] = useState<IFund[]>([]);
  const [checked, setChecked] = useState<boolean>(false);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const filterCtx: any = useContext(FilterCtx);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  const handleFundsToggleChange = (e) => {
    setChecked(e.value);
    filterCtx.setFundsToggle(e.value);
    filterCtx.setFunds([]);
    setValue([]);
    let tempArray = filterCtx.slicerChoices;
    let tempGroupsArray = filterCtx.initialGroup;
    if (e.value) {
      filterCtx.setSlicerChoices([...filterCtx.slicerChoices, 'fundName']);
      filterCtx.setInitialGroup([...filterCtx.initialGroup, { field: 'fundName' }]);
    } else {
      tempArray = filterCtx.slicerChoices.filter((item) => item !== 'fundName');
      tempGroupsArray = filterCtx.initialGroup.filter((item) => item.field !== 'fundName');
      filterCtx.setSlicerChoices(tempArray);
      filterCtx.setInitialGroup(tempGroupsArray);
    }
  };

  const handleFundChange = (event): void => {
    setValue(event.target.value);
  };

  const handleFundsFilterChange = (event: any) => {
    setFilterChoice(filterBy(cashChoice.slice(), event.filter));
  };

  useEffect(() => {
    setChecked(filterCtx.slicerChoices.indexOf('fundName') + 1 > 0);
    getFunds()
      .then((res: IFund[]) => {
        setFilterChoice(res);
        setCashChoice(res);
      })
      .catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    if (table === 'documents' && filterCtx.funds) {
      setValue(filterCtx.funds);
    } else {
      setValue(filterCtx.fundsActivity);
    }
  }, [impersonation]);

  useEffect(() => {
    if (table === 'documents') {
      filterCtx.setFunds(value);
    } else {
      filterCtx.setFundsActivity(value);
    }
  }, [value]);

  return (
    <div className='funds-filter-wrapper pointer'>
      <MultiSelect
        className={toggleOn && checked ? 'multiselect-padding-left custom-dropdown-style filters-dropdown filters-dropdown-with-slicer' : toggleOn && !checked ? 'custom-dropdown-style filters-dropdown filters-dropdown-with-slicer' : 'custom-dropdown-style filters-dropdown'}
        data={filterChoice}
        textField='name'
        dataItemKey='id'
        value={value}
        placeholder={t('FILTERS.FUNDS')}
        filterable={true}
        disabled={toggleOn && checked}
        onChange={handleFundChange}
        onFilterChange={handleFundsFilterChange}
      />
      {toggleOn && checked && filterCtx.slicerChoices.indexOf('fundName') + 1 > 0 && (
        <div className='switch-number-container'>
          <span>{filterCtx.slicerChoices.indexOf('fundName') + 1}</span>
        </div>
      )}
      {toggleOn && (
        <div className='switch-container'>
          <Switch onLabel={''} offLabel={''} checked={checked} onChange={handleFundsToggleChange} />
        </div>
      )}
    </div>
  );
};

export default FundsFilter;
